import { RAN_DB_DELETE_SITE } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const deleteSiteRanDb = async (id, deleteData) => {
  try {
    const response = await apiClient.put(RAN_DB_DELETE_SITE(id), deleteData);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
